import type { OrderTableSettingsData } from '@frontend/api';

import { CheckboxField as GenericCheckboxField } from 'components/listTablePage';

type OrderTableSettingsFormFieldName = keyof OrderTableSettingsData;

export type CheckboxFieldProps<
  FieldName extends OrderTableSettingsFormFieldName,
> = {
  name: FieldName;
  text: string;
};

export const CheckboxField = <
  FieldName extends OrderTableSettingsFormFieldName,
>(
  props: CheckboxFieldProps<FieldName>,
) => {
  return <GenericCheckboxField {...props} />;
};
